/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Threewaysvalve2Inputs */



/**
* | output |
* | --- |
* | "Three-way valve" |
*
* @param {Br_History_Key_Threewaysvalve2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_threewaysvalve2 = /** @type {((inputs?: Br_History_Key_Threewaysvalve2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Threewaysvalve2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Three-way valve")
	return /** @type {LocalizedString} */ ("Vanne trois voies")
});
export { br_history_key_threewaysvalve2 as "br_history_key_threeWaysValve" }